import { render, staticRenderFns } from "./ToggleMinimized.vue?vue&type=template&id=19bb9a10"
import script from "./ToggleMinimized.vue?vue&type=script&lang=js"
export * from "./ToggleMinimized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports